import { client } from '@trello/graphql';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';
import { memberId } from '@trello/session-cookie';
// eslint-disable-next-line no-restricted-imports
import { BoardResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { closedBoardsState } from 'app/gamma/src/modules/state/ui/closed-boards';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
import {
  ClosedBoardsDocument,
  ClosedBoardsQuery,
  ClosedBoardsQueryVariables,
} from './ClosedBoardsQuery.generated';
import { featureFlagClient } from '@trello/feature-flag-client';

export const LOAD_CLOSED_BOARDS_SUCCESS = Symbol(
  'loaders/LOAD_CLOSED_BOARDS_SUCCESS',
);

export type LoadClosedBoardsSuccessAction = Action<
  typeof LOAD_CLOSED_BOARDS_SUCCESS,
  BoardResponse[]
>;

const loadClosedBoardsSuccess = actionCreator<LoadClosedBoardsSuccessAction>(
  LOAD_CLOSED_BOARDS_SUCCESS,
);

export const loadClosedBoards = (): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    closedBoardsState.setValue({ isLoading: true, hasError: false });

    const { data, error } = await client.query<
      ClosedBoardsQuery,
      ClosedBoardsQueryVariables
    >({
      query: ClosedBoardsDocument,
      variables: {
        id: memberId || '',
      },
      fetchPolicy: featureFlagClient.get('fep.use-cache-for-loaders', false)
        ? 'cache-first'
        : 'network-only',
      context: {
        operationName: 'ClosedBoards',
        document: ClosedBoardsDocument,
      },
    });

    if (error) {
      closedBoardsState.setValue({ isLoading: false, hasError: true });
    } else if (data) {
      if (!data?.member?.boards) {
        return;
      }
      closedBoardsState.setValue({ isLoading: false, hasError: false });

      dispatch(loadClosedBoardsSuccess(data?.member?.boards));
    }
  };
};
